import styled from 'styled-components';
import { CommonDiv } from 'styles/common';
import { Link } from 'react-router-dom';
import InvoiceSvg from 'assets/images/appointment/invoice.svg';
import Invoice24Svg from 'assets/images/appointment/invoice24.svg';
import InvoiceBlueSvg from 'assets/images/appointment/invoice-blue.svg';
import InvoicePaidSvg from 'assets/images/appointment/paid.svg';
import PaymentSvg from 'assets/images/appointment/payment.svg';
import ChangeSvg from 'assets/images/appointment/change.svg';
import CertificateEditSvg from 'assets/images/invoice/cert-edit.svg';

const EmptyBlockWrapper = styled.div`
  min-height: 443px;
`;

const EmptyBlock = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  display: inline-block;
`;

const InvoiceImg = styled.img.attrs({
  src: InvoiceSvg
})``;

const CreateNewInvoiceBtn = styled(CommonDiv.withComponent(Link))`
  margin: 0 auto;
  margin-top: 40px;
  max-width: 200px;
  display: block;
  line-height: 20px;
  border-radius: 4px;
  text-align: center;
  background-color: ${props =>
    props.disabled ? props.theme.color.disabled : props.theme.color.primary};
  padding: 10px 0;
  color: #fff;
  text-decoration: none;
`;

const InvoiceBlock = styled.div`
  position: relative;
  text-align: center;
  min-height: inherit;
  height: calc(100% - 70px);
`;

const InvoiceEmptyText = styled(CommonDiv)`
  margin-top: 25px;
  font-size: 18px;
  color: ${props => props.theme.color.label};
`;

const BodyBlock = styled.div`
  margin: 0 30px;
  height: ${props => (props.withTotal ? 'calc(100% - 80px)' : 'inherit')};
`;

const PaymentBlock = styled.div`
  text-align: left;
  :after {
    float: left;
    width: 0;
    color: ${props => props.theme.color.border};
    white-space: nowrap;
    content: '.....................................................................................................................................................................................................';
  }
`;
const PaymentList = styled.ul`
  max-width: 40em;
  padding: 0;
  margin: 0;
  overflow-x: hidden;
  list-style: none;
  min-height: 320px;
  overflow-y: auto;
  box-sizing: content-box;
  ::-webkit-scrollbar {
    width: 0px; /* remove scrollbar space */
    background: transparent; /* optional: just make scrollbar invisible */
  }
`;

const PaymentItem = styled.li`
  :first-child {
    padding-top: 0;
  }
  padding: 12px 0;
`;

const SpanLeft = styled(CommonDiv.withComponent('span'))`
  padding-right: 0.33em;
  background: white;
`;

const SpanRight = styled(CommonDiv.withComponent('span'))`
  float: right;
  padding-left: 0.33em;
  background: white;
  position: relative;
  z-index: 1;
`;

const NamenclatureNumber = styled(CommonDiv)`
  font-size: 14px;
  color: ${props => props.theme.color.label};
  text-align: left;
  margin-top: 2px;
`;

const TitleBlock = styled.div`
  padding: 17px 0;
  display: inline-block;
  width: 100%;
`;

const Title = styled(CommonDiv)`
  font-size: 14px;
  color: ${props => props.theme.color.label};
  display: inline-block;
  float: ${props => props.float};
`;

const TotalBlock = styled.div`
  display: table;
  border-top: 1px solid ${props => props.theme.color.border};
  padding: 24px 30px;
  padding-bottom: 25px;
`;
const InvoiceStatus = styled.div`
  background-color: ${props => props.theme.color.active};
  padding: 17px 15px;
  margin-bottom: 15px;
`;

const InvoiceActiveImg = styled.img.attrs({
  src: InvoiceBlueSvg
})`
  display: inline-block;
  float: left;
  margin-right: 15px;
  margin-top: 5px;
`;

const InvoicePaidImg = styled.img.attrs({
  src: InvoicePaidSvg
})`
  display: inline-block;
  float: left;
  margin-right: 15px;
  margin-top: 5px;
`;

const Invoice24Img = styled.img.attrs({
  src: Invoice24Svg
})`
  width: 24px;
  height: 24px;
`;

const PaymentImg = styled.img.attrs({
  src: PaymentSvg
})`
  margin-right: 20px;
`;

const ChangeImg = styled.img.attrs({
  src: ChangeSvg
})`
  width: 24px;
  height: 24px;
`;

const LabelText = styled(CommonDiv)`
  font-size: 14px;
  color: ${props => props.theme.color.label};
  text-align: left;
`;

const InfoBlock = styled.div`
  padding: 15px 0;
  display: flex;
  position: relative;
  align-items: center;
`;

const InfoDetailsBlock = styled.div`
  margin-left: 1em;
`;

const TotalTitle = styled(CommonDiv)`
  text-align: left;
  display: table-cell;
  white-space: nowrap;
  float: left;
  margin-right: 4px;
  margin-bottom: -2px;
`;

const TotalDots = styled.div`
  display: table-cell;
  border-bottom: 2px dotted ${props => props.theme.color.border};
  width: 100%;
`;

const TotalValue = styled(CommonDiv)`
  display: table-cell;
  white-space: nowrap;
  font-size: 30px;
  font-weight: bold;
  float: right;
  margin-left: 7px;
  margin-bottom: -6px;
`;

const Status = styled(CommonDiv.withComponent('span'))`
  font-size: 24px;
  ${props => props.isPaid && 'color: #24ac8d'};
`;

const ButtonsBlock = styled.div`
  border-top: 1px solid ${props => props.theme.color.border};
  padding: 20px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  > div {
    flex: 1;
    text-align: right;
    &:first-of-type {
      text-align: left;
    }
  }
`;

const DeleteInvoice = styled(CommonDiv.withComponent('button'))`
  border: 2px solid ${props => props.theme.color.error};
  border-radius: 4px;
  color: ${props => props.theme.color.error};
  font-weight: 500;
  background-color: #fff;
  padding: 9px 0px;
  max-width: 170px;
  width: 100%;
`;

const ChangeInvoice = styled(CommonDiv.withComponent('button'))`
  border: 2px solid ${props => props.theme.color.primary};
  border-radius: 4px;
  color: ${props => props.theme.color.primary};
  font-weight: 500;
  background-color: #fff;
  padding: 9px 0px 10px 0px;
  max-width: 170px;
  width: 100%;
`;

const ConfirmPayment = styled(CommonDiv.withComponent('button'))`
  background-color: ${props => props.theme.color.primary};
  color: #fff;
  font-weight: 500;
  border-radius: 4px;
  padding: 10px 0;
  line-height: 20px;
  margin-left: 5%;
  max-width: 170px;
  width: 100%;
`;

const CertificateEditImg = styled.img.attrs({
  src: CertificateEditSvg
})`
  cursor: pointer;
  height: 24px;
  position: absolute;
  right: 0;
  &:hover {
    opacity: 0.7;
  }
`;

export {
  EmptyBlockWrapper,
  EmptyBlock,
  InvoiceBlock,
  InvoiceImg,
  CreateNewInvoiceBtn,
  InvoiceEmptyText,
  BodyBlock,
  PaymentList,
  PaymentItem,
  SpanLeft,
  SpanRight,
  PaymentBlock,
  NamenclatureNumber,
  TitleBlock,
  Title,
  TotalBlock,
  InvoiceStatus,
  InvoiceActiveImg,
  InvoicePaidImg,
  Invoice24Img,
  PaymentImg,
  ChangeImg,
  LabelText,
  InfoBlock,
  InfoDetailsBlock,
  CommonDiv,
  TotalValue,
  TotalDots,
  TotalTitle,
  Status,
  ButtonsBlock,
  DeleteInvoice,
  ChangeInvoice,
  ConfirmPayment,
  CertificateEditImg
};
